"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.IntermediateNodeSchema = exports.IntermediateNodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/assigned-repayment-tape/types");
const v4_1 = require("zod/v4");
exports.artifactType = 'assignedRepaymentTape';
exports.IntermediateNodeConfigSchema = types_1.IntermediateRecordConfigSchema;
// *** Intermediate Record ***
exports.IntermediateNodeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
    creditFacilitySlug: true,
    externalFilename: true,
    loanProductSlug: true,
}).extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    loanProductSlug: v4_1.z.string(),
    creditFacilitySlug: v4_1.z.string(),
    configuration: exports.IntermediateNodeConfigSchema,
});
// *** Db Configuration ***
exports.NodeConfigSchema = v4_1.z.object({
    generatedRepaymentTapeArtifactSlug: v4_1.z
        .string()
        .describe('Generated repayment tape artifact slug'),
    internalRepaymentTapeArtifactSlug: v4_1.z
        .string()
        .describe('Internal repayment tape artifact slug'),
    assignedLoanTapeArtifactSlug: v4_1.z
        .string()
        .describe('Assigned loan tape artifact slug'),
});
// *** Db Record ***
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
    creditFacilitySlug: true,
    externalFilename: true,
    loanProductSlug: true,
}).extend({
    type: v4_1.z.literal(exports.artifactType),
    creditFacilitySlug: v4_1.z.string(),
    configuration: exports.NodeConfigSchema,
    externalFilename: v4_1.z.null(),
    loanProductSlug: v4_1.z.string(),
});
//# sourceMappingURL=node.js.map